export default __webpack_public_path__ + "static/media/clairefontainemini.5aaa8705.jpg";